import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons'
import React, { useEffect, useRef, useState } from 'react';
import styled from "styled-components";
import Icon from './Icon';


const Footer = styled.div`
  margin-left: ${props => props.leftOffset || '0px'};
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: center;
`

const FoooterButton = styled.button`
  height: 30px;
  background-color: #ff513c;
  color: #fff;
  border: 0;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  padding: 7px 10px;
  outline: none;
  text-transform: uppercase;
  transition: top .35s ease;
  box-shadow: inset 0 7px 9px -7px rgba(0,0,0,0.7);
`

const FooterIcon = styled(FontAwesomeIcon)`
  transform: ${props => props.active == "true" ? "rotate(-180deg)" : ""};
`

const Title = styled.div`
  background-color: #fff;
  display: flex;
  flex-orientatin: row;
  border-radius: 3px;
  border-bottom-right-radius: ${props => props.active ? "0px" : "3px"};
  align-items: center;
  box-shadow: 2px 2px 10px 0 rgba(0,0,0,.25);
`

const TitleIconWrapper = styled.div`
  height: 60px;
  width: 60px;
  background-color: #ff513c;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
  padding: 6px 6px 6px 6px;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  position: relative;
  overflow: hidden;
`

const titleIconStyle = {
  fontSize: "35px",
  color: "#fff",
  marginTop: 0,
}

const TitleText = styled.div`
  font-size: 14px;
  display: flex;
  padding: 4px 12px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-self: stretch;
  justify-content: center;
  position: relative;
`

const CollapsableContainer = styled.div`
  transition: height 0.4s, background-color 0.4s;
  overflow: hidden;
  background: #fff;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  transition: top .35s ease,padding .35s ease,height .35s ease;
  box-shadow: -4px 6px 10px -4px rgba(0,0,0,.25),4px 6px 10px -4px rgba(0,0,0,.25);
  margin-left: ${props => props.leftOffset || '0px'};
  height: ${props => props.height ? props.height : "0px" }
  `

const CollapsableContainerContent = styled.div`
  padding: 20px 20px 12px;
`

export const useUpdateCollapsableHeight = () => {
  const ref = useRef();
  const [active, setActive] = useState(false)
  const getChildrenHeight = () => (ref.current && ref.current.scrollHeight + 20) // +20 as padding is not counted
  const [collapseHeight, setCollapseHeight] = useState(0)
  const updateHeight = ()=>{
    if (active) {
      setCollapseHeight(getChildrenHeight())
    } else {
      setCollapseHeight(0)
    }
  }
  useEffect(() => {
    updateHeight()
  }, [active])

  return { ref, active, setActive, collapseHeight, updateHeight }
}

const CollapsableBody = React.forwardRef(({collapseHeight, children}, ref) => {
  return (
    <CollapsableContainer height={`${collapseHeight}px`} leftOffset={'54px'}>
      <CollapsableContainerContent ref={ref}>
        {children}
      </CollapsableContainerContent>
    </CollapsableContainer>
  )
});

const CollapsableCard = React.forwardRef(({icon, title, closeBtnText, active, setActive, collapseHeight, children}, ref) => {
  return (
    <>
      <Title active={active}>
        <TitleIconWrapper>
          <Icon icon={icon} style={titleIconStyle} />
        </TitleIconWrapper>
        <TitleText>
          {title}
        </TitleText>
      </Title>
      <CollapsableBody ref={ref} collapseHeight={collapseHeight}>
        {children}
      </CollapsableBody>
      <Footer leftOffset={'54px'}>
        <FoooterButton onClick={() => (setActive(!active))}>
          <FooterIcon icon={faChevronDown} active={new Boolean(active).toString()}/>
            {closeBtnText}
          <FooterIcon icon={faChevronDown} active={new Boolean(active).toString()}/>
        </FoooterButton>
      </Footer>
    </>
  )
});

export default CollapsableCard